import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    "id": null, // optional 
    "anh_hien_thi": null, // optional Ảnh hiển thị
    "vi_tri": null, // optional Vị trí quảng cáo
    "chinh_sach": null, // optional Chính sách quảng cáo
    "gia_tien": [], // optional Giá tiền cho các vị trí
    "nguoi_tao": null, // optional Người tạo
    "hien_thi": null, // optional Hiển thị
    "thoi_gian_tao": null, // optional Thời gian tạo
    "thoi_gian_sua_cuoi": null, // optional Thời gian lần sửa bản ghi cuối cùng
    "nguoi_sua_cuoi": null, // optional Mã người sửa cuối
    "ngon_ngu": null, // required Ngôn ngữ hiển thị. vi - Tiếng việt, en - Tiếng Anh
}

model.trangThai = [

    {
        code: true,
        text: "Đã xử lý"
    },
    {
        code: false,
        text: "Chưa xử lý"
    },
];

model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },
};

model.validForm = {
    'chinh_sach': [ValidService.required],
    'man_hinh': [ValidService.required],
    'anh_hien_thi': [ValidService.required],
    'hien_thi': [ValidService.required],
    'ngon_ngu': [ValidService.required],
    'vi_tri': [ValidService.required]
}

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            ho_ten: "",
            sdt: "",
        },
        valid: {
            ho_ten: [],
            sdt: []
        },
        operator: {
            ho_ten: "$vn_text=", //:regex:, $vn_text=Viêt nam
            sdt: ":regex:",
        }
    }
};

export default model;